import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  padding: 80px 30px;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.1);

  @media (${mobileXXLargeMax}) {
    padding: 0;
  }
`;

export const BgBox = styled.div<{ smallBackground: string; largeBackground: string }>`
  background-size: cover;
  background-position: center;
  background-image: url(${(props) => props.largeBackground});
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;

  @media (${mobileXXLargeMax}) {
    background-image: url(${(props) => props.smallBackground});
    position: static;
    height: 135px;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const FormBox = styled.div<{ show?: boolean; hide?: boolean }>`
  max-width: 460px;
  width: 100%;
  background-color: ${(props) => props.theme.background};
  padding: 50px;
  margin-right: 30px;

  @media (${mobileXXLargeMax}) {
    max-width: none;
    padding: 30px 20px;
    margin-right: 0;
  }

  ${(props) =>
    props.show !== undefined &&
    `
    @media (${laptopMediumMax}) {
      display: ${props.show ? 'block' : 'none'};
    }
  `}
`;
